<label
  kendoTooltip
  class="k-label"
  [hidden]="config?.options?.labelIgnore"
  [ngStyle]="config?.options?.style?.label"
  [attr.title]="config?.options?.tooltip"
  [class.disabled-field]="config?.disabled"
>
  {{ config?.label }}
  @if (config?.options?.tooltip && config?.options?.showTooltipIcon) {
    <i class="far fa-info-circle m-1" [title]="config?.options?.tooltip"></i>
  }
  @if (hasConflicts) {
    <span
      class="conflict-resolver position-relative d-inline-block"
      (click)="$event.preventDefault()"
    >
      <i
        class="fa fa-exclamation-circle ms-1 cursor-pointer"
        [ngClass]="conflictIconClass"
        [attr.title]="'A value differs from the suggested default — click to resolve'"
        (click)="toggleConflictPopover()"
      ></i>
      @if (showConflictPopover) {
        <div
          class="card shadow position-absolute p-2"
          style="
            z-index: 1080;
            min-width: 280px;
            left: 0;
            top: 1.6rem;
            white-space: normal;
            font-weight: 400;
          "
        >
          <i
            class="fa fa-times position-absolute cursor-pointer text-secondary"
            style="top: 0.4rem; right: 0.5rem"
            title="Close"
            (click)="toggleConflictPopover()"
          ></i>
          @for (
            c of conflictStates;
            track c.targetFormControlName;
            let last = $last
          ) {
            <div>
              <div class="fw-bold mb-1 pe-4">
                {{ c.valueLabel || c.targetLabel }}
                @if (c.status === 'resolved') {
                  <span class="text-secondary small fw-normal">
                    · resolved (you can still change this)
                  </span>
                }
              </div>
              <div class="mb-2 small">
                @if (conflictSourcesSummary(c); as sources) {
                  @if (c.defaultIsEmpty) {
                    There is no {{ c.valueLabel || c.targetLabel }} associated
                    with {{ sources }}. You currently have '{{
                      c.currentDisplay
                    }}'. Keep it or clear it?
                  } @else {
                    {{ c.valueLabel || c.targetLabel }} '{{ c.defaultDisplay }}'
                    is associated with {{ sources }}. You currently have '{{
                      c.currentDisplay
                    }}'. Which would you like to use?
                  }
                } @else {
                  @if (c.defaultIsEmpty) {
                    This selection has no associated
                    {{ c.valueLabel || c.targetLabel }}. You currently have '{{
                      c.currentDisplay
                    }}'. Keep it or clear it?
                  } @else {
                    The suggested {{ c.valueLabel || c.targetLabel }} is '{{
                      c.defaultDisplay
                    }}'. You currently have '{{ c.currentDisplay }}'. Which
                    would you like to use?
                  }
                }
              </div>
              <div class="d-flex gap-2 flex-wrap">
                <button
                  kendoButton
                  type="button"
                  themeColor="primary"
                  size="small"
                  (click)="resolveConflict(c.targetFormControlName, 'default')"
                >
                  @if (c.defaultIsEmpty) {
                    Clear (no default)
                  } @else {
                    Switch to default: {{ c.defaultDisplay }}
                  }
                </button>
                <button
                  kendoButton
                  type="button"
                  fillMode="outline"
                  size="small"
                  (click)="resolveConflict(c.targetFormControlName, 'keep')"
                >
                  Keep: {{ c.currentDisplay }}
                </button>
              </div>
            </div>
            @if (!last) {
              <hr class="my-2" />
            }
          }
        </div>
      }
    </span>
  }
</label>
@if (config?.options?.admin?.allowDelete) {
  <i
    [hidden]="config?.options?.labelIgnore"
    class="fas fa-times ms-3 cursor-pointer c-red"
    (click)="removeItem()"
  ></i>
}
@if (config?.instruction) {
  <p class="mb-3">{{ config?.instruction }}</p>
}
